export const PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH = '532px';
export const PRESCRIPTION_ISSUING_PANELS_GAP = '30px';
